var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.7 7.5-5.46-6.33-1.08-1.25H9.26a3.13 3.13 0 0 0-3.13 3.14v3.98h1.94V3.82c0-.98.79-1.77 1.76-1.77h11.03v5.22a3.52 3.52 0 0 0 3.53 3.53h3.82L28 25.88c0 .97-.78 1.75-1.75 1.76l-16.57-.01c-.89 0-1.6-.87-1.6-1.94V24.4H6.13v1.9c0 1.92 1.28 3.47 2.85 3.47h17.84a3.14 3.14 0 0 0 3.13-3.14V8.97L28.7 7.5",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.22 25.38H0V6.07h20.22v19.31M1.94 23.44h16.34V8H1.94",
    fill: "#C28B00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C28B00",
    d: "M4.33 10.82h5.57v1.96l-3.05 5.81h3.08v2.23H4.1v-1.96l3.05-5.81H4.33v-2.23ZM11.1 10.82h2.35v10H11.1v-10ZM14.95 10.82h3.05c1.86 0 3.07 1.16 3.07 3.03 0 1.9-1.21 3.09-3.07 3.09h-.7v3.88h-2.35v-10Zm2.35 2.2v1.74h.52c.57 0 .86-.31.86-.89 0-.55-.29-.85-.86-.85h-.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZip);
export default ForwardRef;